// NPM packages
import styled from '@emotion/styled';
import { StoryblokComponent, useStoryblok } from '@storyblok/react';
import React from 'react';
import { useLocation } from 'react-router-dom';

// All other imports
import NotFoundContent from 'components/core/NotFoundContent';
import CircularProgress from 'components/core/CircularProgress';

const Root = styled.div({
  overflow: 'visible',
});

export interface StaticPageProps {
  className?: string;
}

export default function StaticPage(
  props: StaticPageProps
): React.ReactElement | null {
  const { className } = props;
  const webappPathname = useLocation().pathname;
  const storyblokPathname = webappPathname.replace('/sb/', '');

  const story = useStoryblok(storyblokPathname!, {
    version: 'draft',
    resolve_relations: [
      'resourceCategoryList.resourceCategories',
      'textResource.authors',
      'videoResource.authors',
    ],
  });

  let body = <CircularProgress text={'Loading...'} />;

  if (story.content) {
    const displayNotFound =
      webappPathname.startsWith('/sb/people') || story.content.displayNotFound;
    if (displayNotFound) {
      body = <NotFoundContent />;
    } else {
      body = <StoryblokComponent blok={story.content} />;
    }
  }

  return <Root className={className}>{body}</Root>;
}
